import {Box} from '@material-ui/core';
import Pagination from 'components/pagination';
import Spinner from 'components/spinner';
import Table from 'components/tables/table';
import {autobind} from 'core-decorators';
import {formatDate, getMaxPage} from 'core/utils';
import ordersQuery from 'graphql/queries/orders.gql';
import React, {Component, Fragment} from 'react';
import {graphql, withApollo} from 'react-apollo';
import BoxIcon from 'views/home/supervisor-home/expenditure-by-organization/assets/box-icon';

@graphql(ordersQuery, {
    name: 'ordersData',
    options: {
        fetchPolicy: 'network-only',
        variables: {
            options: {pageSize: 5, page: 0},
        },
    },
})
@withApollo
@autobind
export default class OrdersTable extends Component {
    /**
     * @typedef {{options: {pageSize: number, page: number}}} OrderQueryVariables
    * @type {{
    * ordersData: {
    * refetch: (variables: OrderQueryVariables) => void
    * fetchMore: (options: {variables: OrderQueryVariables}) => void
    * loading: boolean
    * orders: {
    * page: number
    * count: number
    * items: Array<{
    *   id: number
    *   created: number
    *   category: {name: string}
    *   createdBy: {firstName: string, lastName: string, email: string}
    *   status: {name}}
    * }>
    * }
    * }
    * }}
    */
    props = {};
    rowsPerPage = 5;

    /** @param {number} page  */
    handlePageClick(page) {
        this.props.ordersData.refetch({
            options: {
                page,
                pageSize: this.rowsPerPage,
            },
        });
    }

    handlePreviousPage() {
        this.handlePageClick(this.props.ordersData.orders.page - 1);
    }

    handleNextPage() {
        this.handlePageClick(this.props.ordersData.orders.page + 1);
    }

    render() {
        const {loading, orders} = this.props.ordersData;
        if (loading) return <Spinner />;
        const {items: data, count, page: currentPage} = orders;
        return (
            <Fragment>
                <Table
                    data={data}
                    columns={[
                        {key: 'id', label: 'Pedidos', render: row => <Fragment><BoxIcon color='primary' style={{verticalAlign: 'sub'}} />&nbsp;#{row.id}</Fragment>},
                        {key: 'createdBy', label: 'Realizado por', render: row => <Fragment>{row.createdBy.firstName} {row.createdBy.lastName} - {row.createdBy.email}</Fragment>},
                        {key: 'created', label: 'Fecha', format: formatDate},
                        {key: 'category.name', label: 'Tipo'},
                        {key: 'status.name', label: 'Estado'},
                    ]}
                    openOrderDetailOnRowClick
                />
                <Box mt={8}>
                    <Pagination
                        maxPage={getMaxPage(count, this.rowsPerPage)}
                        active={currentPage}
                        handlePreviousPage={this.handlePreviousPage}
                        handleNextPage={this.handleNextPage}
                        handlePageClick={this.handlePageClick}
                    />
                </Box>
            </Fragment>
        );
    }
}


// WEBPACK FOOTER //
// ./components/tables/orders-table.js